import {z} from 'zod';

export const desklyConnectUsageDay = z.object({
    date: z.string(),
    totalActiveUsers: z.number(),
    desklyConnectUsers: z.number(),
});

export type DesklyConnectUsageDay = z.infer<typeof desklyConnectUsageDay>;

export const desklyConnectUsageStatistics = z.array(desklyConnectUsageDay);

export type DesklyConnectUsageStatistics = z.infer<typeof desklyConnectUsageStatistics>;
